import { Action } from 'typescript-fsa';
import * as actions from './actions';
import { Dispatch } from 'redux';
import { inference, uploadImage } from '../../../apis';
import { loadingOperations } from '../loading';
import { getLogger } from '../../../utils';
import { systemStateMessageOperations } from '..';

const execute = ({ koujiBangou, inferenceId, imageStr, contentType }
      : { koujiBangou: string, inferenceId: string, imageStr: string, contentType: string}) => async (dispatch: Dispatch<Action<any>>) => {
  loadingOperations.startLoading()(dispatch);

  try {
    // 拡張子をcontentTypeから取得する
    const ext = contentType.toLowerCase().endsWith('png')
            ? 'png'
            : 'jpeg'
    // ファイル名生成
    const key = `${inferenceId}-cropped.${ext}`;
    await uploadImage({ key, imageStr, contentType });
    const inferenceResult = await inference({
      koujiBangou,
      inferenceId,
      imagePath: `s3://${process.env.REACT_APP_IMAGEUPLOADBUCKETNAME}/${key}`
    });
    const croppedImage = {
      bucket: process.env.REACT_APP_IMAGEUPLOADBUCKETNAME || '',
      key
    };
    dispatch(actions.execute.done({
      params: { imageStr },
      result: {
        results: inferenceResult.results,
        additionalResult: inferenceResult.additionalResult,
        croppedImage
      }
    }));
  } catch (error) {
    dispatch(actions.execute.failed({ params: { imageStr }, error: error.toString() }))
    getLogger().error('inference/execute()', error);
    systemStateMessageOperations.putError({ message: '通信エラーが発生しました。' })(dispatch);
  } finally {
    loadingOperations.stopLoading()(dispatch);
  }
}

const reset = () => async (dispatch: Dispatch<Action<any>>) => {
  dispatch(actions.reset());
};

export {
  execute,
  reset
};



// WEBPACK FOOTER //
// ./src/redux/modules/inference/operations.ts